import { useTranslation } from 'react-i18next';

import './JoiningMeeting.css';
const JoiningMeeting = () => {
  const { t } = useTranslation();

  return (
    <div className="joining-meeting">
      <div className="joining-meeting__text">{t('入会中...')}</div>

      <div className="joining-meeting__loading-animation">
        <div className="joining-meeting__loading-mask--left" />
        <div className="joining-meeting__loading-animation--img" />
        <div className="joining-meeting__loading-mask--right" />
      </div>
    </div>
  );
};

export default JoiningMeeting;
